<div class="msin-background"></div>

<mat-card appearance="outlined" *ngIf="!hideLoginPanel" class="login-page">
	<mat-card-header>
		<mat-card-title>
			<img class="login-logo" alt="MSIN Logo" src="../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-content>
				<form [formGroup]="form" class="login-form column" (submit)="login()">
					<mat-form-field style="width:100%;">
						<mat-label>Username</mat-label>
						<div style="box-sizing:border-box;">
							<input matInput type="email" placeholder="Username" formControlName="username" />
						</div>
					</mat-form-field>

					<mat-form-field style="width:100%;">
						<mat-label>Password</mat-label>
						<input matInput [type]="hide ? 'password' : 'text'" placeholder="Password"
							formControlName="password" />

						<button type="button" mat-icon-button matSuffix (click)="toggleHide()"
							[attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" tabindex="-1">
							<mat-icon>{{hide ? "visibility_off" : "visibility"}}</mat-icon>
						</button>

					</mat-form-field>

					<button class="w-100" type="submit" mat-raised-button color="primary"
						[disabled]="!form.valid || isLoading">
						<mat-icon *ngIf="isLoading">
							<mat-spinner diameter="18"> </mat-spinner>
						</mat-icon>
						Login
					</button>

					<app-msg [msg]="msg"></app-msg>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="margin-top-sm">
			<mat-card-content appearance="outlined" class="login-content-footer">
				<a mat-button routerLink="/forgot-username">Forgot Username</a>
				<a mat-button routerLink="/forgot-password">Forgot Password</a>
				<hr />
				<p>
					Need help?<br />Contact the MSIN Service Desk:
					<a href="tel:1-800-342-2964">800-342-2964</a>, or email
					<a href="mailto:msinsupport@wested.org">msinsupport&#64;wested.org</a>.
				</p>
				<hr />
				Need an account?
				<a routerLink="/account-request">Request one here</a>.
			</mat-card-content>
		</mat-card>
	</mat-card-content>
</mat-card>

<div *ngIf="!hideLoginPanel" class="bottom-info">
		Build: {{ latestBuildDateTime }} GMT-0700 (Pacific Daylight Time)
</div>

<div *ngIf="hideLoginPanel" class="spinner-overlay">
	<mat-spinner diameter="50"></mat-spinner>
</div>